export default "__VITE_ASSET__B_iFO5Yn__"